import { render, staticRenderFns } from "./scene1.vue?vue&type=template&id=7e0d9345&scoped=true&"
import script from "./scene1.vue?vue&type=script&lang=ts&"
export * from "./scene1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d9345",
  null
  
)

export default component.exports